<template>
  <block-template
    :data="data"
    title="Изображение"
    :possible-next="possibleNext"
    :is-last="isLast"
  >
    <div class="block-image-text">
      <v-img :src="data.content.image" alt="" />
      <div v-html="data.content.text" />
    </div>
  </block-template>
</template>

<script>
import BlockTemplate from "./Template";
export default {
  name: "BlockImageText",
  components: { BlockTemplate },
  props: {
    data: {
      type: Object,
      required: true,
      content: {
        type: Object,
        required: true,
        image: String,
        text: String
      },
      parent_type: {
        type: String,
        required: true
      },
      parent_id: {
        type: Number,
        required: true
      }
    },
    possibleNext: {
      type: Object,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss">
.block-image-text{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
</style>
